
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkouts",
      function () {
        return require("private-next-pages/checkouts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkouts"])
      });
    }
  